import { formatMoney } from "../../../../../utils/generalFormat";
import { ValueCard } from "../../../styles";
import { TotalsData } from "../../../types";

export const Totals: React.FC<{ data: TotalsData }> = ({ data }) => {
  const formatTotal = (value: number): string => {
    if (isNaN(value)) value = 0;
    return formatMoney(value);
  };

  return (
    <>
      <ValueCard>
        <div>
          <p style={{ fontWeight: "bolder" }}>Valor Total da <br/>UR:</p>
          <p>{formatTotal(data.totalUrValue)}</p>
        </div>

        <div>
          <p style={{ fontWeight: "bolder" }}>Valor Total Credor:</p>
          <p>{formatTotal(data.totalCreditorValue)}</p>
        </div>

        <div>
          <p style={{ fontWeight: "bolder" }}>Valor Total Cliente:</p>
          <p>{formatTotal(data.totalClientValue)}</p>
        </div>
      </ValueCard>
    </>
  );
};
